const itemHeight = 40;
const inputWidth = 120;
// Diameter of the connection dots. Small enough not to cover the node, with
// the hover scaling below making them easy to grab anyway
const handleSize = 12;
// How much the dots grow while hovered, so a small dot is still a big target
const handleHoverScale = 1.5;
const bodyPadding = 1;
// Distance between two grid dots, in px. Shared with the auto layout so that a
// snapped layout lands on the dots the grid actually draws
const gridGap = 20;
// Vertical gap between two connection dots stacked on a collapsed node's left
// edge. Slightly more than the dot diameter so they never touch
const collapsedHandleSpacing = 14;
// Frame geometry, in px. The border width never changes with selection so that
// selecting a node can't shift its contents, and the title reuses the radius
// for its top corners because the frame can't clip it: the connection dots
// stick out past the frame edges and `overflow: hidden` would cut them off
const frameBorderRadius = 10;
const frameBorderWidth = 1;

// Step-by-step execution colors, shared by the node glow and the edge flow so
// that a step reads as one single highlight
const stepValueColor = "#f57c00"; // orange[700]
const stepDerivativeColor = "#d81b60"; // pink[600]
const stepDoneColor = "#2e7d32"; // green[800]

// Ring around a node the manual derivative mode will accept next. It borrows
// the interactive blue rather than joining the step palette: the other three
// colors report what the run did, while this one is an invitation to click
const manualReadyColor = "#1565c0"; // blue[800]

// Resting border of a node frame. It can't reuse the divider color either: at
// 1.24:1 against the node body that color is invisible as an outline, and the
// outline is the whole thing that separates a node from the canvas. These hit
// the 3:1 that WCAG 1.4.11 asks of a UI component boundary
const nodeBorderLightColor = "#8b94a6";
const nodeBorderDarkColor = "rgba(255, 255, 255, 0.34)";

// Grid dots. They can't reuse the divider color: a divider is a solid line
// against a card, while a dot is 2px of color surrounded by canvas, so the same
// value that reads as a hairline disappears entirely as a dot
const gridDotLightColor = "#c3cad6";
const gridDotDarkColor = "rgba(255, 255, 255, 0.22)";
// Diameter of a grid dot, in px. React Flow halves it into the circle radius,
// so anything below 2 lands on a fractional pixel and gets anti-aliased into a
// smudge instead of a dot
const gridDotSize = 2;

export {
  itemHeight,
  inputWidth,
  handleSize,
  handleHoverScale,
  bodyPadding,
  collapsedHandleSpacing,
  frameBorderRadius,
  frameBorderWidth,
  gridDotDarkColor,
  gridDotLightColor,
  gridDotSize,
  gridGap,
  nodeBorderDarkColor,
  nodeBorderLightColor,
  stepValueColor,
  stepDerivativeColor,
  stepDoneColor,
  manualReadyColor,
};
